import { Component, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { AppUserMenu } from '../../@core/models/app.user.menu';
import { menuitems } from '../../@core/models/menu';

import { TimelineService } from "../../@core/data/timeline.service";

import { WaitingDialogComponent } from '../lessons/dialogs/dialog.waiting.component';

import { Router } from '@angular/router';

@Component({
  selector: "edm-modal-menu",
  templateUrl: "./modal-menu.component.html",
  styleUrls: ["./modal-menu.component.scss"],
  standalone: false
})
export class ModalMenuComponent implements OnInit {

  menu: AppUserMenu;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    size: 'lg',
    container: 'nb-layout'
  };

  constructor(
    public activeModal: NgbActiveModal,
    private timelineService: TimelineService,
    private router: Router,
    private modal: NgbModal,
  ) {
    this.timelineService.timeLine$.subscribe(item=> {
      if (item) {
        this.menu = item?.menu
      }
    })
  }

  ngOnInit(): void {}

  closeModal(): void {
    this.modal.dismissAll();
  }

  async openOrPlay(model: menuitems): Promise<void> {

    if (model.action.url.includes('challenge')) {
      const activeModal: NgbModalRef = this.modal.open(WaitingDialogComponent, this.ngbModalOptions);
      const { title, desc } = await this.timelineService.getNotOpenInAppDefaultTexts('challenge');
      activeModal.componentInstance.waitingTitle = title;
      activeModal.componentInstance.waitingSubtitle = desc;
      activeModal.result.then(
        (): void => { },
        (): void => { },
      );
      return
    }

    const actionButton = model.action;
    this.closeModal()
    if (actionButton.type == "EXTERNAL_URL") {

      if (model.open_external == false) {
        const activeModal: NgbModalRef = this.modal.open(WaitingDialogComponent, this.ngbModalOptions);
        const { title, desc } = await this.timelineService.getNotOpenInAppDefaultTexts();
        activeModal.componentInstance.waitingTitle = title;
        activeModal.componentInstance.waitingSubtitle = desc;
        activeModal.result.then(
          (): void => { },
          (): void => { },
        );
        return
      }

      let anchor: HTMLAnchorElement = document.createElement("a");
      anchor.target = "_blank";
      anchor.href = actionButton.url;
      anchor.dispatchEvent(new MouseEvent("click"));
      return;

    } else if (actionButton.type == 'INTERNAL_URL') {
      let actionUrl: string = actionButton.url;
      if (actionUrl.replace('timeline/', '') != actionUrl) {
        const brokenUrl: string[] = actionUrl.split('timeline/');
        this.router.navigate(['comunidade', 'postagem', brokenUrl[1]], {queryParams: {from: 'timeline'}});
      } else if (actionUrl.replace('live/', '') != actionUrl) {
        const brokenUrl: string[] = actionUrl.split('live/');
        this.router.navigate(['comunidade', 'postagem', 'live', brokenUrl[1]], {queryParams: {from: 'timeline'}});
      } else if (actionUrl.includes('lesson/')) {
        const brokenUrl: string[] = actionUrl.split('lesson/');
        const id: string[] = actionUrl.split('product/')[1].split('/');
        this.router.navigate(['produtos', id[0] ,'aula', brokenUrl[1]], {queryParams: {from: 'timeline'}});
      } else if (actionUrl.includes('product/')) {
        const brokenUrl: string[] = actionUrl.split('product/');
        this.router.navigate(['produtos', `${brokenUrl[1]}`], {queryParams: {from: 'timeline'}});
      } else {
        this.router.navigate(['comunidade']);
      }
    } else if (actionButton.type == 'REGISTER') this.router.navigate(['login']);

    else if (actionButton.type == 'HTML') {
      const brokenUrl: string[] = actionButton.url.split('menuitem/');
      console.log(brokenUrl)
      this.timelineService.menu$.next(model)
      this.router.navigate(['menuitem', `${brokenUrl[1]}`], {queryParams: {from: 'timeline'}})
      return;
    }

  }
}
